module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onepager-container offerte"
  }, [(_vm.onepager) ? _c('onepager', {
    attrs: {
      "environment": _vm.environment,
      "logo": _vm.logo,
      "multiRowPath": _vm.onepager.multiRowPath,
      "products": _vm.onepager.products,
      "tableConfig": _vm.onepager.tableConfig,
      "template": _vm.getTemplateManager(_vm.onepager.template)
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c292b22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product-list/ProductList.vue
// module id = 662
// module chunks = 0